import React, { useState, useEffect, useRef } from "react"; 
import { createPortal } from "react-dom";
import { saveAs } from "file-saver";
import { addErrorLog } from '../FirestoreDataLoader.tsx';
import { useConfirmToast } from "../alertFunction.tsx";
import { getAuth } from "firebase/auth";
import { auth, aggiornaStatoFileCliente } from "../FirestoreDataLoader.tsx";

interface DataPdf {
  IdPaese_T: string;
  IdCodice_T: string;
  IdPaese_P: string;
  IdCodice_P: string;
  Denominazione_P: string;
  Indirizzo_P: string;
  CAP_P: string;
  Comune_P: string;
  Nazione_P: string;
  IdPaese_C: string;
  IdCodice_C: string;
  Denominazione_C: string;
  Indirizzo_C: string;
  CAP_C: string;
  Comune_C: string;
  Nazione_C: string;
  Numero_fattura: string;
  Divisa: string;
  ImportoTotale: string;
  Data_Acquisto: string;
  Data_pagamento: string;
  oggetto_acquistato: string;
  ProgressivoInvio: string;
  // altri campi 
  FormatoTrasmissione: string;
  CodiceDestinatario: string;
  RegimeFiscale: string;
  TipoDocumento: string;
  Arrotondamento: string;
  NumeroLinea: string;
  Quantita: string;
  AliquotaIVA: string;
  Natura: string;
  AliquotaIVA_Riepilogo: string;
  Natura_Riepilogo: string;
  Arrotondamento_Riepilogo: string;
  Imposta: string;
  CondizioniPagamento: string;
  ModalitaPagamento: string;
}

const xmlDocument = (dataPdf: DataPdf): string => {
  return `<?xml version="1.0" encoding="UTF-8"?>
<ns2:FatturaElettronica 
xmlns:ns2="http://ivaservizi.agenziaentrate.gov.it/docs/xsd/fatture/v1.2" 
versione="${dataPdf.FormatoTrasmissione}">
  <FatturaElettronicaHeader>
    <DatiTrasmissione>
      <IdTrasmittente>
        <IdPaese>${dataPdf.IdPaese_T}</IdPaese> 
        <IdCodice>${dataPdf.IdCodice_T}</IdCodice>
      </IdTrasmittente>
      <ProgressivoInvio>${dataPdf.ProgressivoInvio}</ProgressivoInvio>
      <FormatoTrasmissione>${dataPdf.FormatoTrasmissione}</FormatoTrasmissione>
      <CodiceDestinatario>${dataPdf.CodiceDestinatario}</CodiceDestinatario>
    </DatiTrasmissione>
    <CedentePrestatore>
      <DatiAnagrafici>
        <IdFiscaleIVA>
          <IdPaese>${dataPdf.IdPaese_P}</IdPaese>
          <IdCodice>${dataPdf.IdCodice_P}</IdCodice>
        </IdFiscaleIVA>
        <Anagrafica>
          <Denominazione>${dataPdf.Denominazione_P}</Denominazione>
        </Anagrafica>
        <RegimeFiscale>${dataPdf.RegimeFiscale}</RegimeFiscale>
      </DatiAnagrafici>
      <Sede>
        <Indirizzo>${dataPdf.Indirizzo_P}</Indirizzo>
        <CAP>${dataPdf.CAP_P}</CAP>
        <Comune>${dataPdf.Comune_P}</Comune>
        <Nazione>${dataPdf.Nazione_P}</Nazione>
      </Sede>
      <RiferimentoAmministrazione>P.IVA: ${dataPdf.IdCodice_P}</RiferimentoAmministrazione>
    </CedentePrestatore>
    <CessionarioCommittente>
      <DatiAnagrafici>
        <IdFiscaleIVA>
          <IdPaese>${dataPdf.IdPaese_C}</IdPaese>
          <IdCodice>${dataPdf.IdCodice_C}</IdCodice>
        </IdFiscaleIVA>
        <Anagrafica>
          <Denominazione>${dataPdf.Denominazione_C}</Denominazione>
        </Anagrafica>
      </DatiAnagrafici>
      <Sede>
        <Indirizzo>${dataPdf.Indirizzo_C}</Indirizzo>
        <CAP>${dataPdf.CAP_C}</CAP>
        <Comune>${dataPdf.Comune_C}</Comune>
        <Nazione>${dataPdf.Nazione_C}</Nazione>
      </Sede>
    </CessionarioCommittente>
  </FatturaElettronicaHeader>
  <FatturaElettronicaBody>
    <DatiGenerali>
      <DatiGeneraliDocumento>
        <TipoDocumento>${dataPdf.TipoDocumento}</TipoDocumento>
        <Divisa>${dataPdf.Divisa}</Divisa>
        <Data>${dataPdf.Data_Acquisto}</Data>
        <Numero>${dataPdf.Numero_fattura}</Numero>
        <ImportoTotaleDocumento>${dataPdf.ImportoTotale}</ImportoTotaleDocumento>
        <Arrotondamento>${dataPdf.Arrotondamento}</Arrotondamento>
      </DatiGeneraliDocumento>
    </DatiGenerali>
    <DatiBeniServizi>
      <DettaglioLinee>
        <NumeroLinea>${dataPdf.NumeroLinea}</NumeroLinea>
        <Descrizione>${dataPdf.oggetto_acquistato}</Descrizione>
        <Quantita>${dataPdf.Quantita}</Quantita>
        <DataInizioPeriodo>${dataPdf.Data_Acquisto}</DataInizioPeriodo>
        <DataFinePeriodo>${dataPdf.Data_pagamento}</DataFinePeriodo>
        <PrezzoUnitario>${dataPdf.ImportoTotale}</PrezzoUnitario>
        <PrezzoTotale>${dataPdf.ImportoTotale}</PrezzoTotale>
        <AliquotaIVA>${dataPdf.AliquotaIVA}</AliquotaIVA>
        <Natura>${dataPdf.Natura}</Natura>
      </DettaglioLinee>
      <DatiRiepilogo>
        <AliquotaIVA>${dataPdf.AliquotaIVA_Riepilogo}</AliquotaIVA>
        <Natura>${dataPdf.Natura_Riepilogo}</Natura>
        <Arrotondamento>${dataPdf.Arrotondamento_Riepilogo}</Arrotondamento>
        <ImponibileImporto>${dataPdf.ImportoTotale}</ImponibileImporto>
        <Imposta>${dataPdf.Imposta}</Imposta>
      </DatiRiepilogo>
    </DatiBeniServizi>
    <DatiPagamento>
      <CondizioniPagamento>${dataPdf.CondizioniPagamento}</CondizioniPagamento>
      <DettaglioPagamento>
        <ModalitaPagamento>${dataPdf.ModalitaPagamento}</ModalitaPagamento>
        <ImportoPagamento>${dataPdf.ImportoTotale}</ImportoPagamento>
      </DettaglioPagamento>
    </DatiPagamento>
  </FatturaElettronicaBody>
</ns2:FatturaElettronica>`;
};

const defaultData = (data: any): DataPdf => ({
        ...data,
        FormatoTrasmissione: data.FormatoTrasmissione || "FPR12",
        CodiceDestinatario: data.CodiceDestinatario || "0000000",
        RegimeFiscale: data.RegimeFiscale || "RF01",
        TipoDocumento: data.TipoDocumento || "TD01",
        Arrotondamento: data.Arrotondamento || "0.00",
        NumeroLinea: data.NumeroLinea || "1",
        Quantita: data.Quantita || "1.00",
        AliquotaIVA: data.AliquotaIVA || "0.00",
        Natura: data.Natura || "N2.2",
        AliquotaIVA_Riepilogo: data.AliquotaIVA_Riepilogo || "0.00",
        Natura_Riepilogo: data.Natura_Riepilogo || "N2.2",
        Arrotondamento_Riepilogo: data.Arrotondamento_Riepilogo || "0.00",
        Imposta: data.Imposta || "0.00",
        CondizioniPagamento: data.CondizioniPagamento || "TP02",
        ModalitaPagamento: data.ModalitaPagamento || "MP08",
      });

// Controlla i dati e salva l'xml
export const creaXmlFattura = (dataPdf: DataPdf, name: string, errorAlert:any, warningAlert:any, xmlDoc = xmlDocument ) => {
  
  try {
    dataPdf = defaultData(dataPdf);
    const emptyKeys = Object.keys(dataPdf).filter((key) => (dataPdf as any)[key] === "");
    if (emptyKeys.length) {
      warningAlert(`Alcuni dati nel file ${name} sono mancanti!\nControlla e riprova il salvataggio.`);
      return;
    }
    const blob = new Blob([xmlDoc(dataPdf)], { type: "application/xml" });
    saveAs(blob, `${name}.xml`);

  } catch (error:any) {
    addErrorLog("Errore durante il salvataggio del file XML:", error);
    errorAlert(`${error.code}`, "Errore durante il salvataggio.");
  }
};

interface XmlEditorModalProps {
  isOpen: boolean;
  onClose: () => void;
  selectedFile: { name: string };
  fileData: Map<string, { data_dict: any , origTotalImport: any, origValuta: any, originalFileName: string; }>;
  setFileData: React.Dispatch<React.SetStateAction<Map<string, { data_dict: any }>>>;
}

const modalRoot = document.getElementById("modal-root") || document.body;

// Componente helper per input auto-dimensionante e gestione del ref
const AutoSizingInput: React.FC<{
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  className?: string; // Per stili futuri, se necessario
}> = ({ value, onChange, className }) => {
  const spanRef = useRef<HTMLSpanElement>(null);
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (spanRef.current && inputRef.current) {
      inputRef.current.style.width = `${spanRef.current.offsetWidth + 8}px`; 
    }
  }, [value]); // Ricalcola la larghezza quando il valore cambia

  return (
    <>
      {/* Span nascosto per misurare la larghezza del testo */}
      <span ref={spanRef} style={{ visibility: 'hidden', position: 'absolute', whiteSpace: 'pre', fontSize: 'inherit', fontFamily: 'inherit' }}>
        {value}
      </span>
      <input 
        ref={inputRef}
        type="text" 
        value={value} 
        onChange={onChange} 
        style={{ border: 'none', background: 'transparent', width: 'auto', display: 'inline', textAlign: 'center' }} 
        className={className}
      />
    </>
  );
};


export const XmlEditorModal: React.FC<XmlEditorModalProps> = ({
  isOpen,
  onClose,
  selectedFile,
  fileData,
  setFileData,
}) => {
  
  const { errorAlert, warningAlert } = useConfirmToast();
  const data = fileData.get(selectedFile.name)?.data_dict;
  const [editableData, setEditableData] = useState<DataPdf | null>(null);
  const [originalData, setOriginalData] = useState<DataPdf | null>(null);

  useEffect(() => {
    if (data) {
      //  valori di default
      const dData = defaultData(data)
      setEditableData(dData);
      setOriginalData(JSON.parse(JSON.stringify(dData))); // Copia per il ripristino
    }
  }, [data]);

  if (!isOpen || !editableData) return null;

  const handleInputChange = (key: keyof DataPdf, value: string) => {
    setEditableData((prev) => prev ? { ...prev, [key]: value } : null);
  };

  const handleSave = async() => {
    if (editableData) {
      const auth = getAuth();
      const user = auth.currentUser;
      const clienteUid = sessionStorage.getItem('clienteUid') || '';
      const originalFileName = String(fileData.get(selectedFile.name)?.originalFileName);
      try{
        await aggiornaStatoFileCliente( clienteUid, originalFileName, String(user?.uid), 'Elaborato');
      }catch(error){};
      creaXmlFattura(editableData, selectedFile.name, errorAlert, warningAlert);
      setFileData((prevData) => {
          const newData = new Map(prevData);
          const currentFileData = newData.get(selectedFile.name) || {}; 
          const updatedFileData = {
            ...currentFileData, // Mantiene origTotalImport e origValuta
            data_dict: originalData 
          };
          newData.set(selectedFile.name, updatedFileData);
          return newData;
      });
      onClose();
    }
  };

  // Funzione per gestire il tasto "Annulla"
  const handleBack = () => {
    if (originalData) {
      // Ripristina i dati al loro valore originale 
      setFileData((prevData) => {
          const newData = new Map(prevData);
          const currentFileData = newData.get(selectedFile.name) || {}; 
          const updatedFileData = {
            ...currentFileData, // Mantiene origTotalImport e origValuta
            data_dict: originalData 
          };
          newData.set(selectedFile.name, updatedFileData);
          return newData;
      });
    }
    onClose();
  };

  const tagStyle = { color: '#242dafff' };
  const attribute1Style = { color: '#10c05fff' };
  const attribute2Style = { color: '#c02a10ff' };

  return createPortal(
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        backgroundColor: "rgba(0,0,0,0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999,
      }}
    >
      <div
        style={{
          background: "#fff",
          padding: "1rem",
          borderRadius: "8px",
          width: "60%",
          maxWidth: "1200px",
          height: "80%",
          display: "flex",
          flexDirection: "row",
        }}
      >
        <div style={{ flex: 1, marginRight: "1rem", overflow: "auto", fontFamily: "monospace", fontSize: "14px", lineHeight: "1.5",backgroundColor:'#fcfcffff', borderRadius:'4px', boxShadow:'inset 0 1px 8px 1px #d4d4d480' }}>
          <pre style={{ margin: 0, padding: '10px' }}>
            <span style={tagStyle}>{`<?xml version="1.0" encoding="UTF-8"?>`}</span>
            <br />
            <span style={tagStyle}>{`<ns2:FatturaElettronica `}</span>
            <span style={attribute2Style}>{`xmlns:ns2`}</span><span style={tagStyle}>{`="`}</span><span style={attribute1Style}>{`http://ivaservizi.agenziaentrate.gov.it/docs/xsd/fatture/v1.2`}</span><span style={tagStyle}>{`" `}</span>
            <span style={attribute2Style}>{`versione`}</span><span style={tagStyle}>{`="`}</span><AutoSizingInput value={editableData.FormatoTrasmissione} onChange={(e) => handleInputChange('FormatoTrasmissione', e.target.value)} />{/*<span style={attribute1Style}>{`FPR12`}</span>*/}<span style={tagStyle}>{`">`}</span>
            <br />
            <span style={tagStyle}>{`  <FatturaElettronicaHeader>`}</span>
            <br />
            <span style={tagStyle}>{`    <DatiTrasmissione>`}</span>
            <br />
            <span style={tagStyle}>{`      <IdTrasmittente>`}</span>
            <br />
            <span style={tagStyle}>{`        <IdPaese>`}</span>
            <AutoSizingInput  value={editableData.IdPaese_T} onChange={(e) => handleInputChange('IdPaese_T', e.target.value)} />
            <span style={tagStyle}>{`</IdPaese>`}</span>
            <br />
            <span style={tagStyle}>{`        <IdCodice>`}</span>
            <AutoSizingInput    value={editableData.IdCodice_T} onChange={(e) => handleInputChange('IdCodice_T', e.target.value)} />
            <span style={tagStyle}>{`</IdCodice>`}</span>
            <br />
            <span style={tagStyle}>{`      </IdTrasmittente>`}</span>
            <br />
            <span style={tagStyle}>{`      <ProgressivoInvio>`}</span>
            <AutoSizingInput    value={editableData.ProgressivoInvio} onChange={(e) => handleInputChange('ProgressivoInvio', e.target.value)} />
            <span style={tagStyle}>{`</ProgressivoInvio>`}</span>
            <br />
            <span style={tagStyle}>{`      <FormatoTrasmissione>`}</span>
            <AutoSizingInput    value={editableData.FormatoTrasmissione} onChange={(e) => handleInputChange('FormatoTrasmissione', e.target.value)} />
            <span style={tagStyle}>{`</FormatoTrasmissione>`}</span>
            <br />
            <span style={tagStyle}>{`      <CodiceDestinatario>`}</span>
            <AutoSizingInput    value={editableData.CodiceDestinatario} onChange={(e) => handleInputChange('CodiceDestinatario', e.target.value)} />
            <span style={tagStyle}>{`</CodiceDestinatario>`}</span>
            <br />
            <span style={tagStyle}>{`    </DatiTrasmissione>`}</span>
            <br />
            <span style={tagStyle}>{`    <CedentePrestatore>`}</span>
            <br />
            <span style={tagStyle}>{`      <DatiAnagrafici>`}</span>
            <br />
            <span style={tagStyle}>{`        <IdFiscaleIVA>`}</span>
            <br />
            <span style={tagStyle}>{`          <IdPaese>`}</span>
            <AutoSizingInput    value={editableData.IdPaese_P} onChange={(e) => handleInputChange('IdPaese_P', e.target.value)} />
            <span style={tagStyle}>{`</IdPaese>`}</span>
            <br />
            <span style={tagStyle}>{`          <IdCodice>`}</span>
            <AutoSizingInput    value={editableData.IdCodice_P} onChange={(e) => handleInputChange('IdCodice_P', e.target.value)} />
            <span style={tagStyle}>{`</IdCodice>`}</span>
            <br />
            <span style={tagStyle}>{`        </IdFiscaleIVA>`}</span>
            <br />
            <span style={tagStyle}>{`        <Anagrafica>`}</span>
            <br />
            <span style={tagStyle}>{`          <Denominazione>`}</span>
            <AutoSizingInput    value={editableData.Denominazione_P} onChange={(e) => handleInputChange('Denominazione_P', e.target.value)} />
            <span style={tagStyle}>{`</Denominazione>`}</span>
            <br />
            <span style={tagStyle}>{`        </Anagrafica>`}</span>
            <br />
            <span style={tagStyle}>{`        <RegimeFiscale>`}</span>
            <AutoSizingInput    value={editableData.RegimeFiscale} onChange={(e) => handleInputChange('RegimeFiscale', e.target.value)} />
            <span style={tagStyle}>{`</RegimeFiscale>`}</span>
            <br />
            <span style={tagStyle}>{`      </DatiAnagrafici>`}</span>
            <br />
            <span style={tagStyle}>{`      <Sede>`}</span>
            <br />
            <span style={tagStyle}>{`        <Indirizzo>`}</span>
            <AutoSizingInput    value={editableData.Indirizzo_P} onChange={(e) => handleInputChange('Indirizzo_P', e.target.value)} />
            <span style={tagStyle}>{`</Indirizzo>`}</span>
            <br />
            <span style={tagStyle}>{`        <CAP>`}</span>
            <AutoSizingInput    value={editableData.CAP_P} onChange={(e) => handleInputChange('CAP_P', e.target.value)} />
            <span style={tagStyle}>{`</CAP>`}</span>
            <br />
            <span style={tagStyle}>{`        <Comune>`}</span>
            <AutoSizingInput    value={editableData.Comune_P} onChange={(e) => handleInputChange('Comune_P', e.target.value)} />
            <span style={tagStyle}>{`</Comune>`}</span>
            <br />
            <span style={tagStyle}>{`        <Nazione>`}</span>
            <AutoSizingInput    value={editableData.Nazione_P} onChange={(e) => handleInputChange('Nazione_P', e.target.value)} />
            <span style={tagStyle}>{`</Nazione>`}</span>
            <br />
            <span style={tagStyle}>{`      </Sede>`}</span>
            <br />
            <span style={tagStyle}>{`      <RiferimentoAmministrazione>P.IVA: `}</span>
            <AutoSizingInput    value={editableData.IdCodice_P} onChange={(e) => handleInputChange('IdCodice_P', e.target.value)} />
            <span style={tagStyle}>{`</RiferimentoAmministrazione>`}</span>
            <br />
            <span style={tagStyle}>{`    </CedentePrestatore>`}</span>
            <br />
            <span style={tagStyle}>{`    <CessionarioCommittente>`}</span>
            <br />
            <span style={tagStyle}>{`      <DatiAnagrafici>`}</span>
            <br />
            <span style={tagStyle}>{`        <IdFiscaleIVA>`}</span>
            <br />
            <span style={tagStyle}>{`          <IdPaese>`}</span>
            <AutoSizingInput    value={editableData.IdPaese_C} onChange={(e) => handleInputChange('IdPaese_C', e.target.value)} />
            <span style={tagStyle}>{`</IdPaese>`}</span>
            <br />
            <span style={tagStyle}>{`          <IdCodice>`}</span>
            <AutoSizingInput    value={editableData.IdCodice_C} onChange={(e) => handleInputChange('IdCodice_C', e.target.value)} />
            <span style={tagStyle}>{`</IdCodice>`}</span>
            <br />
            <span style={tagStyle}>{`        </IdFiscaleIVA>`}</span>
            <br />
            <span style={tagStyle}>{`        <Anagrafica>`}</span>
            <br />
            <span style={tagStyle}>{`          <Denominazione>`}</span>
            <AutoSizingInput    value={editableData.Denominazione_C} onChange={(e) => handleInputChange('Denominazione_C', e.target.value)} />
            <span style={tagStyle}>{`</Denominazione>`}</span>
            <br />
            <span style={tagStyle}>{`        </Anagrafica>`}</span>
            <br />
            <span style={tagStyle}>{`      </DatiAnagrafici>`}</span>
            <br />
            <span style={tagStyle}>{`      <Sede>`}</span>
            <br />
            <span style={tagStyle}>{`        <Indirizzo>`}</span>
            <AutoSizingInput    value={editableData.Indirizzo_C} onChange={(e) => handleInputChange('Indirizzo_C', e.target.value)} />
            <span style={tagStyle}>{`</Indirizzo>`}</span>
            <br />
            <span style={tagStyle}>{`        <CAP>`}</span>
            <AutoSizingInput    value={editableData.CAP_C} onChange={(e) => handleInputChange('CAP_C', e.target.value)} />
            <span style={tagStyle}>{`</CAP>`}</span>
            <br />
            <span style={tagStyle}>{`        <Comune>`}</span>
            <AutoSizingInput    value={editableData.Comune_C} onChange={(e) => handleInputChange('Comune_C', e.target.value)} />
            <span style={tagStyle}>{`</Comune>`}</span>
            <br />
            <span style={tagStyle}>{`        <Nazione>`}</span>
            <AutoSizingInput    value={editableData.Nazione_C} onChange={(e) => handleInputChange('Nazione_C', e.target.value)} />
            <span style={tagStyle}>{`</Nazione>`}</span>
            <br />
            <span style={tagStyle}>{`      </Sede>`}</span>
            <br />
            <span style={tagStyle}>{`    </CessionarioCommittente>`}</span>
            <br />
            <span style={tagStyle}>{`  </FatturaElettronicaHeader>`}</span>
            <br />
            <span style={tagStyle}>{`  <FatturaElettronicaBody>`}</span>
            <br />
            <span style={tagStyle}>{`    <DatiGenerali>`}</span>
            <br />
            <span style={tagStyle}>{`      <DatiGeneraliDocumento>`}</span>
            <br />
            <span style={tagStyle}>{`        <TipoDocumento>`}</span>
            <AutoSizingInput    value={editableData.TipoDocumento} onChange={(e) => handleInputChange('TipoDocumento', e.target.value)} />
            <span style={tagStyle}>{`</TipoDocumento>`}</span>
            <br />
            <span style={tagStyle}>{`        <Divisa>`}</span>
            <AutoSizingInput    value={editableData.Divisa} onChange={(e) => handleInputChange('Divisa', e.target.value)} />
            <span style={tagStyle}>{`</Divisa>`}</span>
            <br />
            <span style={tagStyle}>{`        <Data>`}</span>
            <AutoSizingInput    value={editableData.Data_Acquisto} onChange={(e) => handleInputChange('Data_Acquisto', e.target.value)} />
            <span style={tagStyle}>{`</Data>`}</span>
            <br />
            <span style={tagStyle}>{`        <Numero>`}</span>
            <AutoSizingInput    value={editableData.Numero_fattura} onChange={(e) => handleInputChange('Numero_fattura', e.target.value)} />
            <span style={tagStyle}>{`</Numero>`}</span>
            <br />
            <span style={tagStyle}>{`        <ImportoTotaleDocumento>`}</span>
            <AutoSizingInput    value={editableData.ImportoTotale} onChange={(e) => handleInputChange('ImportoTotale', e.target.value)} />
            <span style={tagStyle}>{`</ImportoTotaleDocumento>`}</span>
            <br />
            <span style={tagStyle}>{`        <Arrotondamento>`}</span>
            <AutoSizingInput    value={editableData.Arrotondamento} onChange={(e) => handleInputChange('Arrotondamento', e.target.value)} />
            <span style={tagStyle}>{`</Arrotondamento>`}</span>
            <br />
            <span style={tagStyle}>{`      </DatiGeneraliDocumento>`}</span>
            <br />
            <span style={tagStyle}>{`    </DatiGenerali>`}</span>
            <br />
            <span style={tagStyle}>{`    <DatiBeniServizi>`}</span>
            <br />
            <span style={tagStyle}>{`      <DettaglioLinee>`}</span>
            <br />
            <span style={tagStyle}>{`        <NumeroLinea>`}</span>
            <AutoSizingInput    value={editableData.NumeroLinea} onChange={(e) => handleInputChange('NumeroLinea', e.target.value)} />
            <span style={tagStyle}>{`</NumeroLinea>`}</span>
            <br />
            <span style={tagStyle}>{`        <Descrizione>`}</span>
            <AutoSizingInput    value={editableData.oggetto_acquistato} onChange={(e) => handleInputChange('oggetto_acquistato', e.target.value)} />
            <span style={tagStyle}>{`</Descrizione>`}</span>
            <br />
            <span style={tagStyle}>{`        <Quantita>`}</span>
            <AutoSizingInput    value={editableData.Quantita} onChange={(e) => handleInputChange('Quantita', e.target.value)} />
            <span style={tagStyle}>{`</Quantita>`}</span>
            <br />
            <span style={tagStyle}>{`        <DataInizioPeriodo>`}</span>
            <AutoSizingInput    value={editableData.Data_Acquisto} onChange={(e) => handleInputChange('Data_Acquisto', e.target.value)} />
            <span style={tagStyle}>{`</DataInizioPeriodo>`}</span>
            <br />
            <span style={tagStyle}>{`        <DataFinePeriodo>`}</span>
            <AutoSizingInput    value={editableData.Data_pagamento} onChange={(e) => handleInputChange('Data_pagamento', e.target.value)} />
            <span style={tagStyle}>{`</DataFinePeriodo>`}</span>
            <br />
            <span style={tagStyle}>{`        <PrezzoUnitario>`}</span>
            <AutoSizingInput    value={editableData.ImportoTotale} onChange={(e) => handleInputChange('ImportoTotale', e.target.value)} />
            <span style={tagStyle}>{`</PrezzoUnitario>`}</span>
            <br />
            <span style={tagStyle}>{`        <PrezzoTotale>`}</span>
            <AutoSizingInput    value={editableData.ImportoTotale} onChange={(e) => handleInputChange('ImportoTotale', e.target.value)} />
            <span style={tagStyle}>{`</PrezzoTotale>`}</span>
            <br />
            <span style={tagStyle}>{`        <AliquotaIVA>`}</span>
            <AutoSizingInput    value={editableData.AliquotaIVA} onChange={(e) => handleInputChange('AliquotaIVA', e.target.value)} />
            <span style={tagStyle}>{`</AliquotaIVA>`}</span>
            <br />
            <span style={tagStyle}>{`        <Natura>`}</span>
            <AutoSizingInput    value={editableData.Natura} onChange={(e) => handleInputChange('Natura', e.target.value)} />
            <span style={tagStyle}>{`</Natura>`}</span>
            <br />
            <span style={tagStyle}>{`      </DettaglioLinee>`}</span>
            <br />
            <span style={tagStyle}>{`      <DatiRiepilogo>`}</span>
            <br />
            <span style={tagStyle}>{`        <AliquotaIVA>`}</span>
            <AutoSizingInput    value={editableData.AliquotaIVA_Riepilogo} onChange={(e) => handleInputChange('AliquotaIVA_Riepilogo', e.target.value)} />
            <span style={tagStyle}>{`</AliquotaIVA>`}</span>
            <br />
            <span style={tagStyle}>{`        <Natura>`}</span>
            <AutoSizingInput    value={editableData.Natura_Riepilogo} onChange={(e) => handleInputChange('Natura_Riepilogo', e.target.value)} />
            <span style={tagStyle}>{`</Natura>`}</span>
            <br />
            <span style={tagStyle}>{`        <Arrotondamento>`}</span>
            <AutoSizingInput    value={editableData.Arrotondamento_Riepilogo} onChange={(e) => handleInputChange('Arrotondamento_Riepilogo', e.target.value)} />
            <span style={tagStyle}>{`</Arrotondamento>`}</span>
            <br />
            <span style={tagStyle}>{`        <ImponibileImporto>`}</span>
            <AutoSizingInput    value={editableData.ImportoTotale} onChange={(e) => handleInputChange('ImportoTotale', e.target.value)} />
            <span style={tagStyle}>{`</ImponibileImporto>`}</span>
            <br />
            <span style={tagStyle}>{`        <Imposta>`}</span>
            <AutoSizingInput    value={editableData.Imposta} onChange={(e) => handleInputChange('Imposta', e.target.value)} />
            <span style={tagStyle}>{`</Imposta>`}</span>
            <br />
            <span style={tagStyle}>{`      </DatiRiepilogo>`}</span>
            <br />
            <span style={tagStyle}>{`    </DatiBeniServizi>`}</span>
            <br />
            <span style={tagStyle}>{`    <DatiPagamento>`}</span>
            <br />
            <span style={tagStyle}>{`      <CondizioniPagamento>`}</span>
            <AutoSizingInput    value={editableData.CondizioniPagamento} onChange={(e) => handleInputChange('CondizioniPagamento', e.target.value)} />
            <span style={tagStyle}>{`</CondizioniPagamento>`}</span>
            <br />
            <span style={tagStyle}>{`      <DettaglioPagamento>`}</span>
            <br />
            <span style={tagStyle}>{`        <ModalitaPagamento>`}</span>
            <AutoSizingInput    value={editableData.ModalitaPagamento} onChange={(e) => handleInputChange('ModalitaPagamento', e.target.value)} />
            <span style={tagStyle}>{`</ModalitaPagamento>`}</span>
            <br />
            <span style={tagStyle}>{`        <ImportoPagamento>`}</span>
            <AutoSizingInput    value={editableData.ImportoTotale} onChange={(e) => handleInputChange('ImportoTotale', e.target.value)} />
            <span style={tagStyle}>{`</ImportoPagamento>`}</span>
            <br />
            <span style={tagStyle}>{`      </DettaglioPagamento>`}</span>
            <br />
            <span style={tagStyle}>{`    </DatiPagamento>`}</span>
            <br />
            <span style={tagStyle}>{`  </FatturaElettronicaBody>`}</span>
            <br />
            <span style={tagStyle}>{`</ns2:FatturaElettronica>`}</span>
          </pre>
        </div>
        <div style={{ display: "flex", flexDirection: "column", justifyContent: "flex-start" }}>
          <button
            onClick={handleSave}
            className="button-style"
            style={{ marginBottom: "1rem", padding: "10px 20px" }}
          >
            Salva XML
          </button>
          <button
            onClick={handleBack}
            className="button-styleX"
            style={{padding: "10px 20px", backgroundColor:'#cf3a3aff'}}
          >
            Annulla
          </button>
        </div>
      </div>
    </div>,
    modalRoot
  );
};
